import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderSection = styled("header")`
  width: 100%;
  background-color: var(--paper);
  color: var(--ink);
  position: relative;
  z-index: 1000;
`;

export const TopDeskBar = styled("div")`
  width: 100%;
  background-color: var(--chapter-dark);
  color: var(--paper);
  padding-block: 8px;
  padding-inline: var(--margin);
  font-family: 'Barlow', sans-serif;
  font-size: var(--step-small);
  font-variant-numeric: tabular-nums;

  .desk-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .desk-rates {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  .desk-rate-item {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
    color: #CBD5E1;
  }

  .desk-rate-item strong {
    color: var(--paper);
    font-weight: 700;
  }

  @media (max-width: 900px) {
    .desk-rate-item.hide-tablet {
      display: none;
    }
  }

  @media (max-width: 600px) {
    padding-block: 6px;
    .desk-rate-item.hide-mobile {
      display: none;
    }
    .desk-rates {
      gap: 12px;
    }
  }
`;

export const CurrencySwitchButton = styled("button")`
  background-color: var(--brand-blue);
  color: var(--paper);
  border: none;
  padding: 4px 12px;
  font-family: 'Barlow', sans-serif;
  font-size: var(--step-small);
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.18s var(--ease-out), transform 0.18s var(--ease-out);

  &:hover {
    background-color: var(--brand-green-dark);
  }
`;

export const MainNavRow = styled("div")`
  width: 100%;
  padding-inline: var(--margin);
  padding-block: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  @media (max-width: 600px) {
    padding-block: 10px;
  }
`;

export const LogoContainer = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: var(--ink);

  img {
    width: 44px;
    height: 44px;
    display: block;
    flex-shrink: 0;
  }

  .brand-lockup {
    display: flex;
    flex-direction: column;
    line-height: 1;
  }

  .brand-title {
    font-family: 'Oswald', sans-serif;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: var(--brand-blue);
  }

  .brand-title span {
    color: var(--brand-green-dark);
  }

  .brand-sub {
    font-family: 'Barlow', sans-serif;
    font-size: var(--step-small);
    font-weight: 600;
    color: var(--muted);
    margin-top: 2px;
  }

  @media (max-width: 600px) {
    gap: 10px;

    img {
      width: 38px;
      height: 38px;
    }

    .brand-sub {
      display: none;
    }
  }
`;

export const DesktopNav = styled("nav")`
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const NavRouteLink = styled(Link)`
  font-family: 'Barlow', sans-serif;
  font-size: var(--step-body);
  font-weight: 600;
  color: var(--ink);
  text-decoration: none;
  padding-block: 6px;
  transition: color 0.18s var(--ease-out);

  &:hover,
  &:focus {
    color: var(--brand-blue);
  }
`;

export const NavCtaLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 10px 20px;
  background-color: var(--brand-green-dark);
  color: var(--paper);
  font-family: 'Oswald', sans-serif;
  font-size: var(--step-body);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  text-decoration: none;
  transition: background-color 0.18s var(--ease-out), transform 0.18s var(--ease-out);

  &:hover,
  &:focus {
    background-color: var(--brand-blue);
    color: var(--paper);
    transform: translateY(-1px);
  }
`;

export const MobileMenuTrigger = styled("button")`
  display: none;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 8px 16px;
  background-color: var(--chapter-dark);
  color: var(--paper);
  border: none;
  font-family: 'Oswald', sans-serif;
  font-size: var(--step-body);
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;

  @media (max-width: 1024px) {
    display: inline-flex;
  }
`;

export const MobileDrawerPanel = styled("div")`
  background-color: var(--chapter-dark);
  color: var(--paper);
  padding: 20px var(--margin) 28px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  a {
    color: var(--paper);
    font-family: 'Oswald', sans-serif;
    font-size: var(--step-lead);
    text-transform: uppercase;
    text-decoration: none;
    padding-block: 6px;
  }

  .mobile-cta {
    margin-top: 8px;
    background-color: var(--brand-green-dark);
    color: var(--paper);
    text-align: center;
    padding: 12px 20px;
    font-size: var(--step-body);
  }
`;
